import React from 'react'
import { Modal, message } from 'antd'
import { formatMessage } from '../utils/common'
export const modalError = ({ content, contentCn }, cb) => {
  return Modal.error({
    width: 500,
    className: 'nike_confirm nike_zoom',
    // getContainer: document.getElementById('main-container'),
    title: formatMessage('languageObj.commonLocale.errorTitle'),
    autoFocusButton: null,
    content: (
      <>
        {content}
        {contentCn ? (
          <>
            <br />
            {contentCn}
          </>
        ) : null}
      </>
    ),
    onOk: () => {
      cb && cb()
    }
  })
}
export const modalInfo = ({ content, contentCn }, cb) => {
  return Modal.info({
    width: 500,
    className: 'nike_confirm nike_zoom',
    // getContainer: document.getElementById('main-container'),
    title: formatMessage('languageObj.commonLocale.infoTitle'),
    autoFocusButton: null,
    content: (
      <>
        {content}
        {contentCn ? (
          <>
            <br />
            {contentCn}
          </>
        ) : null}
      </>
    ),
    onOk: () => {
      cb && cb()
    }
  })
}
export const modalSuccess = ({ content, contentCn }, cb) => {
  return Modal.success({
    width: 500,
    className: 'nike_confirm nike_zoom',
    // getContainer: document.getElementById('main-container'),
    title: formatMessage('languageObj.commonLocale.successTitle'),
    autoFocusButton: null,
    content: (
      <>
        {content}
        {contentCn ? (
          <>
            <br />
            {contentCn}
          </>
        ) : null}
      </>
    ),
    onOk: () => {
      cb && cb()
    }
  })
}
export const modalWarning = ({ content, contentCn }, cb) => {
  return Modal.warning({
    width: 500,
    className: 'nike_confirm nike_zoom',
    // getContainer: document.getElementById('main-container'),
    title: formatMessage('languageObj.commonLocale.warningTitle'),
    autoFocusButton: null,
    content: (
      <>
        {content}
        {contentCn ? (
          <>
            <br />
            {contentCn}
          </>
        ) : null}
      </>
    ),
    onOk: () => {
      cb && cb()
    }
  })
}
export const modalConfirm = ({ content, contentCn, title }, cb) => {
  Modal.confirm({
    width: 500,
    className: 'nike_confirm nike_zoom',
    // getContainer: document.getElementById('main-container'),
    title: title || formatMessage('languageObj.commonLocale.confirmTitle'),
    autoFocusButton: null,
    content: (
      <>
        {content}
        {contentCn ? (
          <>
            <br />
            {contentCn}
          </>
        ) : null}
      </>
    ),
    onOk: () => {
      cb && cb()
    }
  })
}

export const messageModal = (type, { content, contentCn }) => {
  message[type]({
    className: 'nike_message nike_zoom',
    // getContainer: document.getElementById('main-container'),
    content: (
      <>
        {content}
        {contentCn ? (
          <>
            <br />
            {contentCn}
          </>
        ) : null}
      </>
    )
  })
}
